/**
 * The account-settings pages. The app shell shows the settings rail on them instead of the main
 * rail, and the profile shell lays them out as narrow pages.
 */
const ACCOUNT_SETTINGS_ROUTES = [
    '/profile/personal-info',
    '/profile/notification-settings',
    '/profile/change-password'
];

/** True when url is an account-settings page; a query string or fragment does not change that. */
export function isAccountSettingsUrl(url: string): boolean {
    return ACCOUNT_SETTINGS_ROUTES.some(route => url.startsWith(route));
}
